"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.urlValidationSchema = void 0;
const yup_1 = require("yup");
exports.urlValidationSchema = (0, yup_1.string)().required("form.validations.valueMissing");
//# sourceMappingURL=url.js.map